import { StandardProduct } from '@/models/sku';
import { useSkuImg } from '@/utils/uiHelper';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Descriptions, Space, Typography } from 'antd';
import React from 'react';
import Price from '../Price';

interface StandardProductDescProps {
  product: StandardProduct;
  onRequestAdd?: (product: StandardProductDescProps['product']) => void;
  onRequestCancel?: () => void;
}
const StandardProductDesc: React.FC<StandardProductDescProps> = ({
  product,
  onRequestAdd,
  onRequestCancel = () => {},
}: StandardProductDescProps) => {
  const getProductImg = useSkuImg();

  const productGallery = product.gallery && product.gallery.length ? product.gallery : product.originGallery;

  return (
    <>
      <Descriptions size={'small'} title="产品信息" bordered column={3}>
        <Descriptions.Item label="产品" span={3}>
          <div style={{ display: 'flex' }}>
            {/*<div*/}
            {/*  style={{*/}
            {/*    width: 100,*/}
            {/*    height: 100,*/}
            {/*    background: `url(${getProductImg(*/}
            {/*      productGallery ? productGallery[0] : ''*/}
            {/*    )}) no-repeat center center`,*/}
            {/*    backgroundSize: 'contain',*/}
            {/*  }}>*/}
            <img
              style={{ maxWidth: 100, display: 'block', alignSelf: 'center' }}
              src={getProductImg(productGallery ? productGallery[0] : '', 100)}
              alt={product.productName}
            />
            <div style={{ paddingLeft: 15 }}>{product.productName}</div>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label="条码" span={3}>
          {product.barcode}
        </Descriptions.Item>
        <Descriptions.Item label="规格" span={3}>
          {product.type}
        </Descriptions.Item>
        {product.price ? (
          <Descriptions.Item label="参考零售价" span={3}>
            <Price value={product.price} />
          </Descriptions.Item>
        ) : null}
        {product.manufacturerName ? (
          <Descriptions.Item label="制造商" span={3}>
            {product.manufacturerName}
          </Descriptions.Item>
        ) : null}
        {product.width ? (
          <Descriptions.Item label="尺寸" span={3}>
            <Space>
              宽: <Typography.Text code>{product.width}mm</Typography.Text>
              高: <Typography.Text code>{product.height}mm</Typography.Text>
              深: <Typography.Text code>{product.depth}mm</Typography.Text>
            </Space>
          </Descriptions.Item>
        ) : null}
        {onRequestAdd && (
          <Descriptions.Item span={3}>
            <Space>
              <Button
                onClick={() => {
                  onRequestAdd(product);
                }}
                className="form-main-submit"
                icon={<PlusOutlined />}
                type="primary">
                添加到商品库
              </Button>
              <Button
                onClick={() => {
                  onRequestCancel();
                }}
                className="form-main-submit">
                取消
              </Button>
            </Space>
          </Descriptions.Item>
        )}
      </Descriptions>
    </>
  );
};

export default StandardProductDesc;
